module.exports = __webpack_public_path__ + "static/media/we-accept-eur.df16c057.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/assets/we-accept-eur.png
// module id = 747
// module chunks = 0